export class PaisesModel {
  id: number;
  nome: string;
}



// WEBPACK FOOTER //
// ./src/app/paises/paises.model.ts